<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SearchIcon",
});
</script>

<template>
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_137_686)">
      <path d="M10.5801 10.9375L13.2118 13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.0405 6.875C12.0405 3.7684 9.68395 1.25 6.77706 1.25C3.87017 1.25 1.51367 3.7684 1.51367 6.875C1.51367 9.9816 3.87017 12.5 6.77706 12.5C9.68395 12.5 12.0405 9.9816 12.0405 6.875Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_137_686">
        <rect width="14.0357" height="15" fill="white" transform="translate(0.345703)"/>
      </clipPath>
    </defs>
  </svg>

</template>

<style scoped lang="scss">

</style>